import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FooterContactComponent } from './footer-contact/footer-contact.component';
import { FooterHelpComponent } from './footer-help/footer-help.component';
import {
  EmailConfig,
  EmailURLConfigurationResponse,
  UrlConfig,
} from '@modules/admin/interfaces/admin-url.interface';
import { AdminService } from '@modules/admin/services/admin.service';
import { filter } from 'rxjs';
import { ICON_NAMES } from '@modules/cat/constants';
import { NRIconComponent } from '@shared/components/nr-icon/nr-icon.component';

/**
 * Footer component displaying footer-related information.
 * Provides links to contact and help sections.
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        FooterContactComponent,
        FooterHelpComponent,
        NRIconComponent,
    ],
})
export class FooterComponent {
    urlConfigData: UrlConfig[] = [];
    emailConfigData: EmailConfig[] = [];
    icons = ICON_NAMES;
    /**
     * The current year, dynamically assigned at runtime.
     * Used for displaying copyright information.
     */
    currentYear: number = new Date().getFullYear()

  constructor(private readonly adminService: AdminService) {}
  ngOnInit(): void {
    this.getFooterLinks();
  }

  getFooterLinks() {
    this.adminService.adminEmailsandUrls$
      .pipe(filter((config) => config.urls.length > 0 || config.emails.length > 0))
      .subscribe((response: EmailURLConfigurationResponse) => {
        this.urlConfigData = response.urls?.length ? response.urls : [];
        this.emailConfigData = response.emails?.length
          ? response.emails
          : [];
      });
  }

  /**
   * Scrolls the page smoothly to the top when called.
   * Typically used in a "Back to Top" button.
   */
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
